import { generatePath } from "react-router"

// Base routes
export const BASE_ROUTE = "/"
export const PRACTICE_PROFILE_BASE_ROUTE = "/practice"
export const PROVIDER_PROFILE_BASE_ROUTE = "/provider"
export const PRACTICE_INDIVIDUALS_BASE_ROUTE = "/practiceIndividuals"
export const PRACTICE_INVITATIONS_BASE_ROUTE = "/practiceInvitations"
export const TASKBOARD_BASE_ROUTE = "/taskboard"
export const PRACTICE_RATES_BASE_ROUTE = "/practiceRates"
export const USER_ROLES_ROUTE = "/userRoles"
export const GETTING_STARTED_ROUTE = "/gettingStarted"
export const SITE_OUTAGE_RESTRICTED_ROUTE = "/siteOutage"
export const AFFILIATE_RELATIONS_ACTIONS_ROUTE = "/affiliateRelationsActions"
export const PAYMENTS_BASE_ROUTE = "/payments"
export const REFERRALS_BASE_ROUTE = "/referrals"
export const CASE_VIEW_BASE_ROUTE = "/caseView"
export const MANAGED_PRACTICES_BASE_ROUTE = "/managedPractices"
export const ORPHANED_PROVIDER_PROMPT_ROUTE = "/orphanedProviderPrompt"
export const ORPHANED_PRACTICE_CREATION_ROUTE = "/orphanedPracticeCreation"
export const ORPHANED_PRACTICE_CREATION_FLOW_PLACEHOLDER_ROUTE =
  "/orphanedPracticeCreationFlowPlaceholder"

export const appRoutes = {
  ADVANCED_SEARCH: "/advancedSearch",
  USER_ROLES_ROUTE: "/userRoles",
  HA_LOGIN_ROUTE: "/haLogin",
  TERMS_OF_USE_ROUTE: "/termsOfUse",
  CONTACT_US_ROUTE: "/contactUsPage",
  LEGAL_AND_PRIVACY_ROUTE: "/legalAndPrivacyPage",
  HELP_ROUTE: "/helpPage",
  TERMS_OF_USE_PAGE_ROUTE: "/termsOfUsePage",
  PROVIDER_SETUP_ROUTE: "/providerSetup",
  PRACTICE_HEADER_ROUTE: "/practiceHeader",
  QA_ROUTE: "/QA",
  HA_SUPPORT_ROUTE: "/support",
  AR_SUPPORT_ROUTE: "/arSupport",
  ACTIVATION_ROUTE: "/activation",
  INTERNAL_ERROR: "/internalError",
  SITE_OUTAGE_RESTRICTED_ROUTE: SITE_OUTAGE_RESTRICTED_ROUTE,
  ADP_SSO: "/adpSso",
  payments: "/payments",
  practice: {
    practiceInformation: {
      INDEX_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/practiceInformation`,
      ADDRESS_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/practiceInformation/address`,
      CONTACT_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/practiceInformation/contact`,
      DETAILS_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/practiceInformation/details`,
    },
    TAX_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/tax`,
    taxInformation: {
      TIN_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/tax/tin`,
      W9_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/tax/w9`,
    },
    LIABILITY_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/liability`,
    OFFICES_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/offices`,
    location: {
      INDEX_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/location`,
      ADDRESS_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/location/address`,
      CONTACT_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/location/contact`,
      DETAILS_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/location/details`,
    },
    PRACTICE_AGREEMENT_ROUTE: `${PRACTICE_PROFILE_BASE_ROUTE}/practiceAgreement`,
  },
  provider: {
    availability: {
      INDEX_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/availability`,
      NEW_PATIENTS_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/availability/newPatients`,
      DAYS_OF_OPERATION_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/availability/daysOfOperation`,
      BLOCK_OUT_DATES_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/availability/blockOutDates`,
    },
    clientFocus: {
      INDEX_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/clientFocus`,
      SPECIALTIES_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/clientFocus/specialties`,
      DEMOGRAPHICS_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/clientFocus/demographics`,
      SESSIONS_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/clientFocus/sessions`, // TODO: remove with FF IsNoVirtualLocationEnabled = "is-No-Virtual-Location-enabled"
    },
    DISCLOSURE_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/disclosure`,
    INSURANCE_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/insurance`,
    personalInformation: {
      INDEX_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/personalInformation`,
      CONTACT_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/personalInformation/contact`,
      BIO_AND_PHOTO_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/personalInformation/bioAndPhoto`,
      DETAILS_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/personalInformation/details`,
    },
    qualifications: {
      INDEX_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/qualifications`,
      LICENSES_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/qualifications/licenses`,
      CREDENTIALS_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/qualifications/credentials`,
      EDUCATION_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/qualifications/education`,
    },
    LIABILITY_INSURANCE_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/liabilityInsurance`,
    LOCATIONS_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/locations`, // TODO: remove with FF IsNoVirtualLocationEnabled = "is-No-Virtual-Location-enabled"
    SERVICES_ROUTE: `${PROVIDER_PROFILE_BASE_ROUTE}/services`,
  },
  practiceIndividuals: {
    INDEX_ROUTE: `${PRACTICE_INDIVIDUALS_BASE_ROUTE}`,
    EDIT_ROUTE: `${PRACTICE_INDIVIDUALS_BASE_ROUTE}Edit`,
  },
  practiceInvitations: {
    INDEX_ROUTE: `${PRACTICE_INVITATIONS_BASE_ROUTE}`,
    ACCEPT_ROUTE: `${PRACTICE_INVITATIONS_BASE_ROUTE}/accept`,
  },
  practiceRates: {
    INDEX_ROUTE: `${PRACTICE_RATES_BASE_ROUTE}`,
  },
  referrals: {
    INDEX_ROUTE: REFERRALS_BASE_ROUTE,
    DETAILS_ROUTE: `${REFERRALS_BASE_ROUTE}/details`,
  },
  caseView: {
    INDEX_ROUTE: CASE_VIEW_BASE_ROUTE,
  },
  taskboard: {
    INDEX_ROUTE: `${TASKBOARD_BASE_ROUTE}`,
    PRACTICE_ROUTE: `${TASKBOARD_BASE_ROUTE}/practice`,
    PROVIDER_ROUTE: `${TASKBOARD_BASE_ROUTE}/provider`,
  },
  ORPHANED_PROVIDER_PROMPT_ROUTE: ORPHANED_PROVIDER_PROMPT_ROUTE,
  ORPHANED_PRACTICE_CREATION_ROUTE: ORPHANED_PRACTICE_CREATION_ROUTE,
  ORPHANED_PRACTICE_CREATION_FLOW_PLACEHOLDER_ROUTE:
    ORPHANED_PRACTICE_CREATION_FLOW_PLACEHOLDER_ROUTE,
}

export const publicRoutes = [
  appRoutes.TERMS_OF_USE_PAGE_ROUTE,
  appRoutes.LEGAL_AND_PRIVACY_ROUTE,
  appRoutes.CONTACT_US_ROUTE,
  appRoutes.HELP_ROUTE,
]

export const allowedUrlsWhileOnboarding = [
  appRoutes.HA_LOGIN_ROUTE,
  GETTING_STARTED_ROUTE,
  ...publicRoutes,
  PRACTICE_PROFILE_BASE_ROUTE,
  appRoutes.PROVIDER_SETUP_ROUTE,
  PROVIDER_PROFILE_BASE_ROUTE,
  appRoutes.ACTIVATION_ROUTE,
  appRoutes.INTERNAL_ERROR,
  appRoutes.ADP_SSO,
  appRoutes.TERMS_OF_USE_ROUTE,
  ORPHANED_PROVIDER_PROMPT_ROUTE,
  ORPHANED_PRACTICE_CREATION_ROUTE,
  ORPHANED_PRACTICE_CREATION_FLOW_PLACEHOLDER_ROUTE,
]

export const appQueryParams = {
  ACTION_TYPE: "actionType",
  PRACTICE_ID: "practiceId",
  PROVIDER_ID: "providerId",
  LOCATION_ID: "locationId",
  REFERRAL_ID: "referralId",
  INDIVIDUAL_ID: "individualId",
  USER_ID: "userId",
  PRACTICE_INVITE_ID: "practiceInviteId",
  PRACTICE_INVITATION_ID: "practiceInvitationId",
  FILTER_BY: "filterBy",
  PAYMENT_PROVIDER_FILTER: "paymentProviderFilter",
  REFERRAL_FILTER_BY: "referralFilterBy",
  REFERRAL_PROVIDER_FILTER: "referralProviderFilter",
  STATUS: "status",
  SORT_BY: "sortBy",
  SORT_ORDER: "sortOrder",
  REFERRAL_PACKET_GUID: "referralPacketGUID",
  CASE_NUMBER: "caseNumber",
}

// TODO-PracticeIndividual: Remove this
export const xUUID = "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"

/**
 * Generates a URL with the provided route parameters.
 *
 * @param {string} url - The base URL with route parameter placeholders.
 * @param {Object} [params={}] - An object containing key-value pairs of route parameters.
 * @param {string | undefined} [params.key] - The value of a route parameter, where 'key' is the parameter name.
 * @returns {string} The URL with the route parameters replaced.
 */
export const getRouteWithParams = (
  url: string,
  params: { [key: string]: string | undefined } = {},
): string => {
  const path = generatePath(url, params)
  return path
}

/**
 * Generates a URL with the provided query parameters.
 *
 * @param {string} url - The base URL.
 * @param {Record<string, string>} queryParams - An object containing key-value pairs of query parameters.
 * @returns {string} The URL with the appended query parameters.
 */
export const getRouteWithQueryParams = (
  url: string,
  queryParams: Record<string, string>,
): string => {
  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(queryParams)) {
    searchParams.append(key, value)
  }
  const fullUrl = `${url}?${searchParams.toString()}`
  return fullUrl
}
